import { authReducer } from "@/entities/auth";
import { aviabookingReferenceReducer } from "@/entities/aviabooking-reference";
import { aviabookingSavedDocumentsReducer } from "@/entities/aviabooking-saved-documents";
import { bonusesReducer } from "@/entities/bonus";
import { bookingsReducer } from "@/entities/booking";
import { businessCardsReducer } from "@/entities/business-cards";
import { communityReducer } from "@/entities/community";
import { communitySectionsAvailabilityReducer } from "@/entities/community-sections-availability";
import { flightsReducer } from "@/entities/flight";
import { groupsReducer } from "@/entities/groups";
import { invitationsReducer } from "@/entities/invitation";
import { invoicesReducer } from "@/entities/invoice";
import { marketingCampaignReducer, marketingCampaignsReducer } from "@/entities/marketing-campaign";
import { onboardingReducer } from "@/entities/onboarding";
import { partnersReducer } from "@/entities/partner";
import { tradingReducer } from "@/entities/trading";
import { usersReducer } from "@/entities/user";
import { bookingPaymentReducer } from "@/features/booking-payment/model";
import { createInvoiceReducer } from "@/features/create-invoice";
import { foundationAccrualReducer } from "@/features/foundation-accrual";
import { tradingTransferReducer } from "@/features/trading";
import { updateApiKeyReducer } from "@/features/update-api-key";
import { updateFormbuilderFieldReducer } from "@/features/update-formbuilder-field";
import { updateGroupReducer } from "@/features/update-group";
import { updateInvitationReducer } from "@/features/update-invitation";
import { updateJobApplicationReducer } from "@/features/update-job-application";
import { updateMarketingCampaignsReducer } from "@/features/update-marketing-campaigns";
import { updatePartnerDiscountReducer } from "@/features/update-partner-discount";
import { updateUserIntegrationReducer } from "@/features/update-user-integration";
import { updateVacancyReducer } from "@/features/update-vacancy";
import { userAccrualReducer } from "@/features/user-accrual";
import { userBroadcastReducer } from "@/features/user-broadcast";
import { restaurantMenuAnalyticsReducer } from "@/features/restaurant-menu-analytics";
import { loyaltyAnalyticsReducer } from "@/features/loyalty-analytics";
import { changeUserGroupReducer } from "@/features/change-user-group"
import { createUserInvitationReducer } from "@/features/create-user-invitation";
import { userBlockReducer } from "@/features/user-block";
import { userDeleteRestoreReducer } from "@/features/user-delete-restore";
import { fillProfileReducer } from "@/features/fill-profile";
import { bookFlightReducer } from "@/pages/aviabooking-book-flight";
import { bonusProcessingTransactionsReducer } from "@/pages/bonus-processing-transactions";
import { bonusTransactionReducer } from "@/pages/bonus-transaction";
import { bonusTransactionsReducer } from "@/pages/bonus-transactions";
import { employeesProfilebuilderReducer } from "@/pages/employees-profilebuilder";
import { employmentReducer } from "@/pages/employment";
import { foundationsReducer } from "@/pages/foundations";
import { partnerDiscountsReducer } from "@/pages/partner-discounts";
import { partnerMapReducer } from "@/pages/partner-map";
import { partnerStoresReducer } from "@/pages/partner-stores";
import { partnerTransactionReducer } from "@/pages/partner-transaction";
import { partnerTransactionsReducer } from "@/pages/partner-transactions";
import { settingsReducer } from "@/pages/settings";
import { socialMarketFoundationsReducer } from "@/pages/social-market-foundations";
import { socialMarketPairReducer } from "@/pages/social-market-pair";
import { socialMarketPartnerReducer } from "@/pages/social-market-partner";
import { socialMarketPartnersReducer } from "@/pages/social-market-partners";
import { socialMarketTransactionsReducer } from "@/pages/social-market-transactions";
import { socialProgramProcessingTransactionsReducer } from "@/pages/social-program-processing-transactions";
import { userReducer } from "@/pages/user-profile";
import { usersProfilebuilderReducer } from "@/pages/users-profilebuilder";
import { businessCardDetailsReducer } from "@/pages/business-card-details";
import { phoneWhitelistReducer } from "@/pages/phone-whitelist";
import { aclReducer } from "@/pages/acl";
import { communityStatisticsReducer } from "@/widgets/community-statistics";
import { communicationServicesReducer } from "@/widgets/communication-services";
import { companyTransactionsStatisticsReducer } from "@/widgets/company-transactions-statistics";
import { partnerSalesReducer } from "@/widgets/partner-sales";
import { sidebarReducer } from "@/widgets/sidebar";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
    sidebar: sidebarReducer,
    partnerStatistics: partnerSalesReducer,
    community: communityReducer,
    communitySectionsAvailability: communitySectionsAvailabilityReducer,
    partners: partnersReducer,
    communityStatistics: communityStatisticsReducer,
    communicationServices: communicationServicesReducer,
    companyTransactionsStatistics: companyTransactionsStatisticsReducer,
    bonuses: bonusesReducer,
    foundations: foundationsReducer,
    employment: employmentReducer,
    bonusTransactions: bonusTransactionsReducer,
    bonusTransaction: bonusTransactionReducer,
    partnerStores: partnerStoresReducer,
    partnerTransactions: partnerTransactionsReducer,
    partnerTransaction: partnerTransactionReducer,
    partnerDiscounts: partnerDiscountsReducer,
    auth: authReducer,
    onboarding: onboardingReducer,
    updatePartnerDiscount: updatePartnerDiscountReducer,
    partnerMap: partnerMapReducer,
    users: usersReducer,
    userAccrual: userAccrualReducer,
    userBroadcast: userBroadcastReducer,
    changeUserGroup: changeUserGroupReducer,
    userBlock: userBlockReducer,
    userDeleteRestore: userDeleteRestoreReducer,
    fillProfile: fillProfileReducer,
    foundationAccrual: foundationAccrualReducer,
    user: userReducer,
    updateVacancy: updateVacancyReducer,
    updateJobApplication: updateJobApplicationReducer,
    settings: settingsReducer,
    updateUserIntegration: updateUserIntegrationReducer,
    updateApiKey: updateApiKeyReducer,
    invitations: invitationsReducer,
    updateFormbuilderField: updateFormbuilderFieldReducer,
    usersProfilebuilder: usersProfilebuilderReducer,
    employeesProfilebuilder: employeesProfilebuilderReducer,
    updateGroup: updateGroupReducer,
    groups: groupsReducer,
    updateInvitation: updateInvitationReducer,
    createUserInvitation: createUserInvitationReducer,
    trading: tradingReducer,
    socialMarketPair: socialMarketPairReducer,
    tradingTransfer: tradingTransferReducer,
    socialMarketTransactions: socialMarketTransactionsReducer,
    socialMarketPartners: socialMarketPartnersReducer,
    socialMarketFoundations: socialMarketFoundationsReducer,
    socialMarketPartner: socialMarketPartnerReducer,
    bonusProcessingTransactions: bonusProcessingTransactionsReducer,
    socialProgramProcessingTransactions: socialProgramProcessingTransactionsReducer,
    marketingCampaign: marketingCampaignReducer,
    marketingCampaigns: marketingCampaignsReducer,
    updateMarketingCampaigns: updateMarketingCampaignsReducer,
    invoices: invoicesReducer,
    createInvoice: createInvoiceReducer,
    aviabookingReference: aviabookingReferenceReducer,
    aviabookingSavedDocuments: aviabookingSavedDocumentsReducer,
    flighs: flightsReducer,
    bookFlight: bookFlightReducer,
    bookings: bookingsReducer,
    bookingPayment: bookingPaymentReducer,
    businessCards: businessCardsReducer,
    businessCardDetails: businessCardDetailsReducer,
    phoneWhitelist: phoneWhitelistReducer,
    acl: aclReducer,
    restaurantMenuAnalytics: restaurantMenuAnalyticsReducer,
    loyaltyAnalytics: loyaltyAnalyticsReducer,
})

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
